﻿import { ValgState } from './Store/Valg/Types';
import { Satser } from './Utilities/SatserApi';
import Tabell from './Models/Tabell';

import AFamiliesituasjonsValg from './Utilities/A-FamiliesituasjonValg';
import BValg from './Utilities/B-Valg';
import CSoskenValg from './Utilities/C-SoskenValg';

export const getA = (state: ValgState): string | undefined => {
    return state.aFamiliesituasjon?.value;
};

export const getB = (state: ValgState): string | undefined => {
    return state.bSivilstatus?.value;
};

export const getBx = (state: ValgState): string | undefined => {
    return state.bEnForelder?.value;
};

export const getC = (state: ValgState): string | undefined => {
    return state.cSosken?.value;
};

export const getTabell = (state: ValgState, satser: Satser): Tabell | null => {
    const nedreInntektsgrense = getNedreInntektsgrense(state, satser);
    const trekk = getTrekk(state, satser);
    const soskentillegg = getSoskentillegg(state, satser);
    //console.log("Nedre: " + nedreInntektsgrense + ", Trekk: " + trekk + ", Søskentillegg: " + soskentillegg);

    if (nedreInntektsgrense < 0 || trekk < 0 || soskentillegg < 0) {
        return null;
    }

    const utgangspunkt = nedreInntektsgrense - trekk + soskentillegg;
    const trinn = satser.ST01_BehovsprovingGrunnstipendTrinnInntekt;

    return {
        rader: [
            { key: 1, fra: 0, til: utgangspunkt, stipend: satser.ST01_GrunnstipendTrinn1 },
            { key: 2, fra: utgangspunkt + 1, til: utgangspunkt + trinn, stipend: satser.ST01_GrunnstipendTrinn2 },
            {
                key: 3,
                fra: utgangspunkt + trinn + 1,
                til: utgangspunkt + trinn * 2,
                stipend: satser.ST01_GrunnstipendTrinn3,
            },
            { key: 4, fra: utgangspunkt + trinn * 2 + 1, stipend: 0 },
        ],
    };
};

const getNedreInntektsgrense = (state: ValgState, satser: Satser): number => {
    if (state.aFamiliesituasjon !== undefined) {
        if (
            state.aFamiliesituasjon.value === AFamiliesituasjonsValg.a1_borSammen ||
            state.aFamiliesituasjon.value === AFamiliesituasjonsValg.a3_enForelder
        ) {
            return satser.ST01_BehovsprovingNedreInntektsgrenseGrunnstipendTabellA;
        } else if (state.aFamiliesituasjon.value === AFamiliesituasjonsValg.a2_borIkkeSammen) {
            return satser.ST01_BehovsprovingNedreInntektsgrenseGrunnstipendTabellB;
        }
    }
    return -1;
};

const getTrekk = (state: ValgState, satser: Satser): number => {
    if (state.bSivilstatus !== undefined) {
        if (state.bSivilstatus.value === BValg.b1_sivilstatusBegge) {
            return satser.ST01_BehovsprovingTilleggInntektNyPartner * 2;
        } else if (state.bSivilstatus.value === BValg.b2_sivilstatusEn) {
            return satser.ST01_BehovsprovingTilleggInntektNyPartner;
        } else if (state.bSivilstatus.value === BValg.b3_sivilstatusIngen) {
            return 0;
        }
    } else if (state.bEnForelder !== undefined) {
        if (state.bEnForelder.value === BValg.b4_valgEnForelderJa) {
            return satser.ST01_BehovsprovingTilleggInntektNyPartner;
        } else if (state.bEnForelder.value === BValg.b5_valgEnForelderNei) {
            return 0;
        }
    } else {
        return 0;
    }

    return -1;
};

const getSoskentillegg = (state: ValgState, satser: Satser): number => {
    if (state.cSosken !== undefined) {
        if (state.cSosken.value === CSoskenValg.c1_ingenSosken) {
            return 0;
        } else if (state.cSosken.value === CSoskenValg.c2_ettSosken) {
            return satser.ST01_KompensasjonPerBarnGrunnstipend;
        } else if (state.cSosken.value === CSoskenValg.c3_toSosken) {
            return satser.ST01_KompensasjonPerBarnGrunnstipend * 2;
        } else if (state.cSosken.value === CSoskenValg.c4_treEllerFlereSosken) {
            return satser.ST01_KompensasjonPerBarnGrunnstipend * 3;
        }
    }

    return -1;
};
